import httpService from '@/services/httpService'
import { types as rootTypes } from '../../index'

export const types = {
  ADD_USER_MANAGER_DATA: 'user-manager/ADD_USER_MANAGER_DATA',
  ADD_ADMIN_AGENCIES: 'user-manager/ADD_ADMIN_AGENCIES',
  ADD_USER_DATA: 'user-manager/ADD_USER_DATA',
  ADD_AGENCY_ROLES: 'user-manager/ADD_AGENCY_ROLES',
  ADD_CLIENT_ROLES: 'user-manager/ADD_CLIENT_ROLES',
  ADD_AGENCY_OPTIONS: 'user-manager/ADD_AGENCY_OPTIONS',
  ADD_CLIENT_ROLES_OPTIONS: 'user-manager/ADD_CLIENT_ROLES_OPTIONS',
  ADD_AGENCY_ROLES_OPTIONS: 'user-manager/ADD_AGENCY_ROLES_OPTIONS',
  ADD_CLIENT_OPTIONS: 'user-manager/ADD_CLIENT_OPTIONS',
  CHANGE_IS_RECENTLY_ADDED: 'user-manager/CHANGE_IS_RECENTLY_ADDED',
  RESET_DATA: 'user-manager/RESET_DATA'
}
const emptyData = {
  userManagerData: [],
  userData: {},
  adminAgencies: [],
  agencyRoles: [],
  clientRoles: [],
  agencyOptions: [],
  clientRolesOptions: [],
  agencyRolesOptions: [],
  clientOptions: [],
  isRecentlyAdded: false
}
const state = { ...emptyData }

const mutations = {
  [types.ADD_USER_MANAGER_DATA]: function (state, userManagerData) {
    state.userManagerData = userManagerData
  },
  [types.ADD_ADMIN_AGENCIES]: function (state, adminAgencies) {
    state.adminAgencies = adminAgencies
  },
  [types.ADD_USER_DATA]: function (state, userData) {
    state.userData = userData
  },
  [types.ADD_AGENCY_ROLES]: function (state, agencyRoles) {
    state.agencyRoles = agencyRoles
  },
  [types.ADD_CLIENT_ROLES]: function (state, clientRoles) {
    state.clientRoles = clientRoles
  },
  [types.ADD_AGENCY_OPTIONS]: function (state, agencyOptions) {
    state.agencyOptions = agencyOptions
  },
  [types.ADD_CLIENT_ROLES_OPTIONS]: function (state, clientRolesOptions) {
    state.clientRolesOptions = clientRolesOptions
  },
  [types.ADD_AGENCY_ROLES_OPTIONS]: function (state, agencyRolesOptions) {
    state.agencyRolesOptions = agencyRolesOptions
  },
  [types.ADD_CLIENT_OPTIONS]: function (state, clientOptions) {
    state.clientOptions = clientOptions
  },
  [types.CHANGE_IS_RECENTLY_ADDED]: function (state, isRecentlyAdded) {
    state.isRecentlyAdded = isRecentlyAdded
  },
  [types.RESET_DATA]: function (state) {
    const data = { ...emptyData }
    delete data.isRecentlyAdded
    Object.assign(state, data)
  }
}

const actions = {
  updateProjectPermission: async function ({ commit }, params) {
    params = JSON.stringify(params)
    const response = await httpService.patch('/user_manager/update-project-permission', { form: params }, { successMessage: 'Updated permission' })
    if (!response) {
      return
    }
    return response
  },
  updateProjectRole: async function ({ commit }, params) {
    params = JSON.stringify(params)
    const response = await httpService.patch('/user_manager/update-project-role', { form: params }, { successMessage: 'Updated role' })
    if (!response) {
      return
    }
    return response
  },
  getUserRoutes: async function ({ commit }, { projectId, userId }) {
    const response = await httpService.get(`/user_manager/routes/${projectId}/${userId}`)
    if (!response || !response.data) {
      return []
    }
    return response.data
  },
  getUserManagerData: async function ({ commit }, clientId) {
    const response = await httpService.get(`/user_manager/data/${clientId}`)
    if (!response) {
      return
    }
    commit(types.ADD_USER_MANAGER_DATA, response.data.user_manager)
    commit(types.ADD_ADMIN_AGENCIES, response.data.admin_agencies)
    commit(rootTypes.ADD_AGENCIES, response.data.agencies, { root: true })
    return response
  },
  getUserPermissions: async function ({ commit }, { userId }) {
    const response = await httpService.get(`/user_manager/${userId}`)
    if (!response || !response.data) {
      return {}
    }
    return response.data
  },
  removeUserRole: async function (store, params) {
    const response = await httpService.delete('/user_manager/delete-user-role', { params, successMessage: 'Role removed successfully' })
    if (!response) {
      return
    }
    return response.data.is_removed
  },
  updateUserRole: async function (store, params) {
    const response = await httpService.patch('/user_manager/update-user-role', params, { successMessage: 'Role updated successfully' })
    if (!response) {
      return
    }
    return response.data.is_updated
  },
  updateUserData: async function ({ commit }, { userId, successMessage, ...params }) {
    params = JSON.stringify(params)
    const response = await httpService.patch(`/user_manager/change-user-data/${userId}`, { form: params }, { successMessage })
    if (!response) {
      return {}
    }
    return { isUpdated: response.data.is_updated, id: response.data.id }
  },
  createNewUserRole: async function ({ commit }, params) {
    const response = await httpService.post(`/user_manager/create-user-role`, params, { successMessage: 'User role created successfully' })
    if (!response) {
      return
    }
    return response.data.is_created
  },
  getUserData: async function ({ commit }, { clientId, userId }) {
    const response = await httpService.get(`/user_manager/${clientId}/user/${userId}`)
    if (!response) {
      return
    }
    commit(types.ADD_USER_DATA, response.data.user_data)
    commit(types.ADD_AGENCY_ROLES, response.data.agency_roles)
    commit(types.ADD_CLIENT_ROLES, response.data.client_roles)
    commit(types.ADD_AGENCY_OPTIONS, response.data.agency_options)
    commit(types.ADD_CLIENT_ROLES_OPTIONS, response.data.client_roles_options)
    commit(types.ADD_AGENCY_ROLES_OPTIONS, response.data.agency_roles_options)
    commit(types.ADD_CLIENT_OPTIONS, response.data.client_options)
    return response
  },
  changeIsRecentlyAdded: function ({ commit }, isRecentlyAdded) {
    commit(types.CHANGE_IS_RECENTLY_ADDED, isRecentlyAdded)
  },
  resetUserManagerData: function ({ commit }) {
    commit(types.RESET_DATA)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
